import { createBrowserHistory } from 'history';
import { page } from './analytics';

const history = createBrowserHistory();

history.listen(() => {
  page();
});

export default history;
